import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  OnInit,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { CoberturaAlertService } from '@core/services/cobertura-alert.service';
import {
  NotificationConnectionState,
  PostoComandoNotification,
  OcorrenciaNotificationService,
} from '@core/services/ocorrencia-notification.service';
import { Posto } from '@core/models/models';

// ESTATÍSTICAS
import { PostoComandoEstatisticas } from '@shared/api/services/estatisticas/estatisticas-info.service';

@Component({
  selector: 'app-posto-comando',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './posto-comando.component.html',
  styleUrl: './posto-comando.component.scss',
})
export class PostoComandoComponent implements OnInit {

  private readonly coberturaSvc = inject(CoberturaAlertService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly router = inject(Router);

  readonly notificationSvc = inject(OcorrenciaNotificationService);
  readonly postoComandoInfo = inject(PostoComandoEstatisticas);

  // DADOS DO POSTO DE COMANDO
  totalOcorrencias = 0;
  porConfirmar = 0;
  urgentes = 0;
  semCobertura = 0;

  // OCORRÊNCIAS DO SIGNALR
  ocorrencias: PostoComandoNotification[] = [];

  postosSemCobertura: Posto[] = [];

  connectionState: NotificationConnectionState = 'disconnected';

  filtro: 'todas' | 'nao-lidas' | 'Urgentes' = 'todas';

  ngOnInit(): void {

    // ESTATÍSTICAS DA API
    this.estatisticasPostoComando();

    // OCORRÊNCIAS EM TEMPO REAL
    this.notificationSvc.notifications$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((items) => {
        this.ocorrencias = items ?? [];
        this.cdr.markForCheck();
      });

    // ESTADO DA CONEXÃO SIGNALR
    this.notificationSvc.connectionState$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((state) => {
        this.connectionState = state;
        this.cdr.markForCheck();
      });

    // POSTOS SEM COBERTURA
    this.coberturaSvc.postosSemCobertura$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((items) => {
        this.postosSemCobertura = items ?? [];
        this.cdr.markForCheck();
      });
  }

  // PEGA AS INFORMAÇÕES DO POSTO DE COMANDO
  private estatisticasPostoComando(): void {
    this.postoComandoInfo.obterPostoComandoEstaisticas().subscribe({
      next: (estatisticas) => {

        this.totalOcorrencias = estatisticas.totalOcorrencias;
        this.porConfirmar = estatisticas.porConfirmar;
        this.urgentes = estatisticas.urgentes;
        this.semCobertura = estatisticas.semCobertura;

        console.log('DADOS DO POSTO DE COMANDO', estatisticas);

        this.cdr.markForCheck();
      },
      error: (error) => {
        console.error(
          'Erro ao carregar estatísticas do Posto de Comando:',
          error
        );
      }
    });
  }

  // FILTRO DA LISTA DE OCORRÊNCIAS
  get ocorrenciasVisiveis(): PostoComandoNotification[] {

    switch (this.filtro) {

      case 'nao-lidas':
        return this.ocorrencias.filter((item) => !item.lida);

      case 'Urgentes':
        return this.ocorrencias.filter(
          (item) => this.notificationSvc.isUrgent(item)
        );

      default:
        return this.ocorrencias;
    }
  }

  abrirOcorrencia(item: PostoComandoNotification): void {

    this.notificationSvc.markAsRead(item);

    const destination = this.notificationSvc.destination(item);
    void this.router.navigate(destination.commands, {
      queryParams: destination.queryParams,
    });
  }

  abrirPosto(posto: Posto): void {
    void this.router.navigate(['/admin/postos', posto.id]);
  }

  atualizar(): void {

    this.estatisticasPostoComando();

    this.coberturaSvc.refresh();

    void this.notificationSvc.refresh();
  }
}